<template>
  <div class="datos-pliego">
    <h3 class="section-title">
      <IconFileDocumentOutline class="section-icon" />
      Datos de imposición
    </h3>
    <el-row :gutter="16">
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Desarrollo</span>
          <span class="data-value">{{ dv(producto.desarrollo, 'mm') }}</span>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Ancho mínimo</span>
          <span class="data-value">{{ dv(producto.anchoMinimo, 'mm') }}</span>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Ancho material</span>
          <span class="data-value">{{ dv(producto.anchoMaterial, 'mm') }}</span>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Total bocas</span>
          <span class="data-value"
            >{{ dv(producto.totalBocas, '', 0) }} ({{ dv(producto.bocasAncho, '', 0) }}×{{
              dv(producto.bocasDesarrollo, '', 0)
            }})</span
          >
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">m² de la imposición</span>
          <span class="data-value">{{ dv(producto.m2PorPliego, 'm2', 4) }}</span>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Metro/pliego</span>
          <span class="data-value">{{ dv(producto.metroPorPliego, 'm') }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import IconFileDocumentOutline from '~icons/mdi/file-document-outline';
import { displayValueConUnidad } from '@/shared/utils/format_produccion.js';

const props = defineProps({
  producto: {
    type: Object,
    required: true,
  },
  isStale: {
    type: Boolean,
    default: false,
  },
});

function dv(valor, unidad, decimales = 2) {
  return displayValueConUnidad(valor, unidad, props.isStale, decimales);
}
</script>

<style scoped>
.datos-pliego {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-icon {
  font-size: 18px;
  color: #409eff;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 0;
}

.data-label {
  font-size: 11px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-value {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  font-family: 'Fira Code', monospace;
}
</style>
